import React from 'react';
import { NavLink, Link, withRouter } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faSignOutAlt, faSignInAlt, faUsersCog, faHome, faUser } from '@fortawesome/free-solid-svg-icons';

// import AdminGroupSelect from 'Components/Partials/AdminGroupSelect';

import User from 'Services/User';
import { asset, filterItemsByAccess } from 'Services/BaseHelpers';
import AdminGroupSelect from "Components/Partials/AdminGroupSelect";
import Header from "Components/Layouts/TopMenu/Header";

class UnAuthHeader extends React.Component {
    /**
     * @var navItems
     * @type {string}
     */
    navItems = [
        // // Pre auth
        // {
        //     to: "/login",
        //     icon: faSignInAlt,
        //     title: "Login",
        //     is_logged_out: true
        // },
        // Post auth
        {
            to: "/welcome",
            title: "Welcome",
        },
        {
            to: "/agenda",
            title: "Agenda",
            is_logged_in: true
        },
        {
            to: "/exhibitors",
            title: "Exhibitors",
            is_logged_in: true
        },
        {
            to: "/attendees",
            title: "Attendees",
            is_logged_in: true
        },
        {
            to: "/networking",
            title: "Networking",
            is_logged_in: true
        },

        // {
        //     to: "/registration",
        //     title: "Registration",
        // },
        // {
        //     to: "/contact-us",
        //     title: "Contact",
        // },
        // {
        //     to: "/information",
        //     title: "Information",
        // },
        // {
        //     to: "/about",
        //     title: "About Bupa",
        // },
        // {
        //     to: "/speakers",
        //     title: "Speakers",
        // },
        {
            to: "/admin",
            icon: faUsersCog,
            title: "Admin",
            is_admin: true,
            is_logged_in: true
        },
        {
            to: "/logout",
            icon: faSignOutAlt,
            title: "Logout",
            is_logged_in: true
        },
    ];

    /**
     * @var state
     * @type {{showOnMobile: boolean}}
     */
    state = {
        showOnMobile: false,
    }

    /**
     * @method render
     * @returns {JSX.Element}
     */
    render() {
        const { showOnMobile } = this.state;
        const { pageTitle, headerImage } = this.props;

        return (
            <div className="flex flex-col bg-white m-2">
                <Header pageVideoHeader={ "bupa-banner.mp4" }/>

                {/*<div className="flex items-center p-5 w-full bg-white text-app-blue mx-auto">*/}
                {/*    /!*<div className={ `flex flex-col lg:items-end w-full` }>*!/*/}
                {/*    /!*    <div className="w-full flex flex-col lg:flex-row justify-start items-center gap-4 lg:gap-8 text-center">*!/*/}
                {/*    /!*        <Link to="/" className="flex items-center cursor-pointer">*!/*/}
                {/*    /!*            <img*!/*/}
                {/*    /!*                src={ asset ( 'images/alt-logo.png' ) }*!/*/}
                {/*    /!*                alt="Logo"*!/*/}
                {/*    /!*                className="h-20 lg:h-20 mr-4"*!/*/}
                {/*    /!*            />*!/*/}
                {/*    /!*        </Link>*!/*/}
                {/*    /!*    </div>*!/*/}
                {/*    /!*</div>*!/*/}
                {/*</div>*/}

                {/*<div*/}
                {/*    className="bg-white text-white   select-none flex items-center flex-wrap lg:flex-nowrap"*/}
                {/*>*/}
                {/*    <div className=" flex flex-col lg:flex-row w-full justify-center  mx-auto gap-5">*/}
                {/*        <FontAwesomeIcon*/}
                {/*            icon={ faBars }*/}
                {/*            size="2x"*/}
                {/*            onClick={ () => this.setState ( { showOnMobile: !showOnMobile } ) }*/}
                {/*            className="block lg:hidden cursor-pointer ml-auto mr-2 text-app-blue"*/}
                {/*        />*/}
                {/*        <div className="w-full m-auto flex justify-center items-center">*/}
                {/*            {headerImage && (*/}
                {/*                <img src={asset(headerImage)} alt="Header" className="w-full h-auto" />*/}
                {/*            ) }*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
        );
    }

}

export default withRouter(UnAuthHeader);
